export default class ApiTeam {
    constructor(Restangular, ApiBaseResponseService) {
        return {
            getTeams() {
                return Restangular
                    .one('groups')
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getTeam(teamId) {
                return Restangular
                    .one('team', teamId)
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            postTeam(team) {
                return Restangular
                    .all('groups')
                    .post(team)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            putTeam(team) {
                return Restangular
                    .one('groups')
                    .customPUT(team)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            deleteTeam(team) {
                return Restangular
                    .one('groups')
                    .remove()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getTeamMembers(param) {
                return Restangular
                    .one('groups/user')
                    .get(param)
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            addTeamMember(email) {
                return Restangular
                    .all('groups/user')
                    .post(null, { userEmail: email })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            removeTeamMember(email) {
                return Restangular
                    .one('groups/user')
                    .remove({ userEmail: email })
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            isGroupAdmin() {
                return Restangular
                    .one('groups/isGroupAdmin')
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            },

            getTeamMember(userId) {
                return Restangular
                    .one('groups/user', userId)
                    .get()
                    .then(ApiBaseResponseService.onSuccess, ApiBaseResponseService.onError);
            }
        };
    }
}

ApiTeam.inject = ['Restangular', 'ApiBaseResponseService'];



/** WEBPACK FOOTER **
 ** ./src/app/services/apiTeam.js
 **/